module.exports = __webpack_public_path__ + "img/hometile_md.83e5cbfd.png";